export const getApiBaseUrl = (): string =>
  window.env?.VITE_API_URL ?? import.meta.env.VITE_API_URL;

export const getDevPortalBaseUrl = (): string =>
  window.env?.VITE_DEV_PORTAL_URL ?? import.meta.env.VITE_DEV_PORTAL_URL;

export const isLocalEnvironment = (): boolean => {
  const baseUrl = getApiBaseUrl();

  return baseUrl?.includes('localhost');
};
